import { render, staticRenderFns } from "./Scan2.vue?vue&type=template&id=d2821776&scoped=true"
import script from "./Scan2.vue?vue&type=script&lang=js"
export * from "./Scan2.vue?vue&type=script&lang=js"
import style0 from "./Scan2.vue?vue&type=style&index=0&id=d2821776&prod&lang=less"
import style1 from "./Scan2.vue?vue&type=style&index=1&id=d2821776&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2821776",
  null
  
)

export default component.exports